var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchIconSm = function SvgSearchIconSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#403f40",
    fillRule: "evenodd",
    stroke: "#403f40",
    strokeWidth: 0.5,
    d: "M13.832 9.354a4.477 4.477 0 1 1-4.477-4.477 4.477 4.477 0 0 1 4.477 4.477zm.121 3.624a5.854 5.854 0 1 0-.974.974l4.346 4.346a.689.689 0 1 0 .974-.974z"
  })));
};
export default SvgSearchIconSm;